import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material';
import { Constants } from 'src/app/core/constants';
import { AssignedPeComponent } from './assigned-pe/assigned-pe.component';
import { UnassignedPeComponent } from './unassigned-pe/unassigned-pe.component';

@Component({
  selector: 'app-package-engineer-assignment',
  templateUrl: './package-engineer-assignment.component.html',
  styleUrls: ['./package-engineer-assignment.component.scss']
})
export class PackageEngineerAssignmentComponent implements OnInit {
  selectedTabIndex: number = 0;
  @ViewChild('UpdatedCurrentAssignments')
  UpdatedCurrentAssignments: AssignedPeComponent;

  @ViewChild('UnassignedTab')
  UnassignedTab: UnassignedPeComponent;

  constructor() { }

  ngOnInit() {
  }

  selectedTabChange(event: MatTabChangeEvent) {
    if (this.selectedTabIndex !== event.index) {
      this.validateTabChange(this.selectedTabIndex);
      if(event.tab.textLabel === Constants.CURRENT_ASSIGNMENTS){
          this.UpdatedCurrentAssignments.searchPEAssignment();
      }
      if(event.tab.textLabel === Constants.UNASSIGNED){
        this.UnassignedTab.getAllUnAssignedPE();
      }
    } else {
      this.validateTabChange(this.selectedTabIndex - 1);
    }
    this.selectedTabIndex = event.index;
  }

  validateTabChange(index: number) { }

}
